import { render, staticRenderFns } from "./TemplateImageUpload.vue?vue&type=template&id=1be6fed2&scoped=true"
import script from "./TemplateImageUpload.vue?vue&type=script&lang=js"
export * from "./TemplateImageUpload.vue?vue&type=script&lang=js"
import style0 from "./TemplateImageUpload.vue?vue&type=style&index=0&id=1be6fed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be6fed2",
  null
  
)

export default component.exports